import { isMobileScreen } from './utils';
import { BREAKPOINTS } from './constants';

const shrink = (item) => {
  item?.classList.remove('expand--open');
  item.setAttribute('aria-expanded', 'false');
};

const expand = (item) => {
  item?.classList.add('expand--open');
  item.setAttribute('aria-expanded', 'true');
};

const rowHandler = (row, menu) => {
  if (row.classList.contains('expand--open')) return shrink(row);
  menu?.querySelectorAll('.expand--open').forEach((item) => shrink(item));
  expand(row);
};

const menuHandler = (menu) => {
  const firstMenuRow = menu?.querySelectorAll('.menu__list-container ul > .menu__list-item--tier1');
  const event = isMobileScreen(BREAKPOINTS.LG) ? 'click' : 'mouseover';

  if (!firstMenuRow) return;

  firstMenuRow.forEach((item) => {

    item.addEventListener(event, (e) => {
      const targetEl = e?.target;
      const isAnchorTag = targetEl?.tagName === 'A';
      const isFirstRow = isAnchorTag && targetEl?.parentElement === item;

      if (isFirstRow) return rowHandler(item, menu);

      const isSecondRow = isAnchorTag && targetEl?.parentElement.classList.contains('menu__list-item--tier2');

      if (isSecondRow) return rowHandler(targetEl?.parentElement, targetEl?.parentElement?.parentElement);

    });
  });
};

export default menuHandler;
